import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const AddEventModal = ({ isOpen, onClose, onSuccess, isLoggedIn }) => {
    const [date, setDate] = useState('');
    const [title, setTitle] = useState('');
    const [shortDescription, setShortDescription] = useState('');
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);

    const BASE_URL = `${process.env.REACT_APP_LINK}`;

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files || []);
        setImages(files);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!date || !title.trim()) {
            toast.warning('Date and Title are required');
            return;
        }

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('date', date);
            formData.append('title', title.trim());
            formData.append('shortDescription', shortDescription.trim());

            // Append files last (some servers require this for multipart)
            images.forEach((file) => {
                formData.append('images', file);
            });

            const response = await axios.post(
                `${BASE_URL}/events/${isLoggedIn.user_id}`,
                formData
            );

            if (response.status === 201) {
                toast.success('Event created successfully');
                setDate('');
                setTitle('');
                setShortDescription('');
                setImages([]);
                onSuccess();
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error creating event');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={onClose}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">Add Event</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="date" className="oms-form-label">Date</label>
                        <input
                            type="date"
                            id="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            required
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="title" className="oms-form-label">Title</label>
                        <input
                            type="text"
                            id="title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter event title"
                            required
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="shortDescription" className="oms-form-label">Short Description</label>
                        <textarea
                            id="shortDescription"
                            value={shortDescription}
                            onChange={(e) => setShortDescription(e.target.value)}
                            placeholder="Enter short description"
                            rows={4}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="images" className="oms-form-label">Upload Images</label>
                        <input
                            type="file"
                            id="images"
                            accept="image/jpeg,image/jpg,image/png,image/webp,image/avif"
                            multiple
                            onChange={handleFileChange}
                        />
                        {images.length > 0 && (
                            <small>{images.length} file(s) selected</small>
                        )}
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={onClose}>Cancel</button>
                        <button type="submit" disabled={loading}>
                            {loading ? 'Adding...' : 'Add Event'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddEventModal;
